
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

import TroubleshootingPlayerCnInside from './TroubleshootingPlayerCnInside.vue'

declareVrunComponent('troubleshootingPlayerCnInside.vrun.component', TroubleshootingPlayerCnInside)

import TroubleshootingPlayerCnOutside from './TroubleshootingPlayerCnOutside.vue'

declareVrunComponent('troubleshootingPlayerCnOutside.vrun.component', TroubleshootingPlayerCnOutside)